import { render, staticRenderFns } from "./App.vue?vue&type=template&id=c96f9308"
import script from "./App.ts?vue&type=script&lang=ts"
export * from "./App.ts?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.0.10@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports